
import { defineComponent } from 'vue'

import { variants } from '~/types/zealTypes'

export default defineComponent({
  name: 'ZTagV2',
  props: {
    type: {
      type: String,
      required: true,
      validator: (value: string) => variants.includes(value)
    },
    hideIcon: {
      type: Boolean,
      default: false
    }
  }
})
